/**
 * Справочник VLAN: назначение по номеру — «11 — ПК и принтеры».
 *
 * Справочник один на всю сеть и ведётся в разделе «Порты». Здесь — то,
 * что нужно интерфейсу: подписи и разбор фильтра, в котором вместо
 * номера можно написать назначение («кассы»).
 */

/** Номер VLAN: 1–4094, без ведущих нулей. null — не номер. */
export function cleanVlanId(value) {
  const s = String(value ?? '').trim();
  if (!/^\d{1,4}$/.test(s)) return null;
  const n = Number(s);
  return n >= 1 && n <= 4094 ? String(n) : null;
}

/** Справочник из ответа сервера → { '11': 'ПК и принтеры' }. */
export const toVlanMap = (list) => Object.fromEntries((list || []).map((v) => [String(v.vlan), v.description]));

/** Подпись VLAN: «11 · ПК и принтеры» или просто «11». */
export function vlanText(vid, map) {
  if (vid == null || vid === '') return '';
  const d = map?.[String(vid)];
  return d ? `${vid} · ${d}` : String(vid);
}

const norm = (s) => String(s ?? '').toLowerCase().replace(/ё/g, 'е').trim();

/**
 * Фильтр VLAN в списке устройств. Номера и прочерк уходят как есть;
 * слова заменяются номерами VLAN, в назначении которых они встречаются:
 * «кассы» → «102», «кассы, 11» → «102,11».
 *
 * @returns {string|null} строка для сервера; null — под слова не подошёл
 *   ни один VLAN, и спрашивать сервер незачем.
 */
export function resolveVlanFilter(input, map) {
  const raw = String(input ?? '').trim();
  if (!raw || /^[-—–]$/.test(raw)) return raw;
  const parts = raw.split(/[,;]+/).map((p) => p.trim()).filter(Boolean);
  const out = new Set();
  let words = false;
  for (const p of parts) {
    if (/^\d+$/.test(p)) { out.add(p); continue; }
    words = true;
    const q = norm(p);
    for (const [vid, d] of Object.entries(map || {})) if (norm(d).includes(q)) out.add(vid);
  }
  if (!out.size) return words ? null : '';
  return [...out].join(',');
}

/**
 * Строки справочника для окна редактирования: описанные VLAN и те, что
 * встречаются в срезе без описания, — по возрастанию номера.
 */
export function vlanDirectoryRows(list, seen) {
  const byId = new Map();
  for (const v of list || []) byId.set(String(v.vlan), { ...v, vlan: String(v.vlan), ports: 0 });
  for (const s of seen || []) {
    const id = cleanVlanId(s.vlan);
    if (!id) continue;
    const row = byId.get(id) || { vlan: id, description: '', ports: 0 };
    row.ports = Number(s.ports) || 0;
    byId.set(id, row);
  }
  return [...byId.values()].sort((a, b) => Number(a.vlan) - Number(b.vlan));
}
